//
// Import vendor scripts deferred.

import WrPlyr from "../src/components/plyr"

document.addEventListener('DOMContentLoaded', () => {
    new WrPlyr()
})